import {
    // QuotaDummyCurrent, QuotaDummyNew,
    QuotaDummyGrowth, QuotaDummyPremium,
} from "../../../../../../components/Modal/SubscribeSwitchPlan/dummy";

export const useDummySubscriptionEng3265 = false;

// Previous = Higher tier plan = Old/Current
const oldSubscription = {
    status: "active",
    trial_ends_at: "2022-08-26 12:04:26",
    ends_at: "2023-08-22 12:04:26",
    suspended_at: null,
    billing_cycle_anchor: "2023-08-22",
    addon_packs: [
        {
            name: "5GB Storage Pack",
            type: "STORAGE",
            value: "5",
            monthly_price: 6.9,
            yearly_price: 69,
            quantity: 3,
        },
        {
            name: "100 Files WhatsApp Pack",
            type: "WHATSAPP",
            value: "100",
            monthly_price: 14.9,
            yearly_price: 149,
            quantity: 2,
        },
    ],
    is_past_due: false,
    // plan_id: 7,
    // plan: {
    //     id: 7,
    //     quotas: QuotaDummyGrowth, // <--- new
    //     name: "Bukku Growth (Monthly)",
    //     description: "Growth.",
    //     billing_cycle: 1,
    //     unit_price: 59,
    //     type: "GROWTH",
    // },
    plan_id: 6,
    plan: {
        id: 6,
        name: "Bukku Premium (Yearly)",
        description: "Premium.",
        billing_cycle: 12,
        unit_price: 990,
        type: "PREMIUM",
        created_at: "2022-06-16 20:59:30",
        updated_at: "2022-06-16 20:59:30",
        // quotas: QuotaDummyPremium, // <--- new
        quotas: QuotaDummyPremium.reduce((acc, cur) => {
            acc[cur.type] = cur.allocation;
            return acc;
        }, {}),
        quota_period: "MONTHLY", // <--- new: Or YEARLY
        scopes: {
            SALE: true,
            SALE_BATCH: true,
            PURCHASE: true,
            PURCHASE_BATCH: true,
            DIGITAL_SHOEBOX: true,
            BANK: true,
            BANK_BATCH: true,
            BANK_RECONCILIATION: true,
            PRODUCT_INVENTORY: true,
            PRODUCT_INVENTORY_MULTI_LOCATION: true,
            PRODUCT_MULTI_UOM: true,
            PRODUCT_MULTI_PRICE: true,
            REPORT: true,
            ACCOUNTING_JOURNAL_ENTRY: true,
            ASSET: true,
            INSTRUCTION: true,
            MULTI_CURRENCY: true,
            TAG: true,
            TAX_SST: true,
            FIELD: true,
            EMAIL_TRACKER: true,
            E_INVOICING: true,
            INVOICE_REMINDER: true,
            PAYMENT_GATEWAY: true,
            MULTI_USER: true,
            MULTI_NUMBER_FORMAT: true,
            MULTI_FORM_DESIGN: true,
        },
    },
    scopes: {
        SALE: true,
        SALE_BATCH: true,
        PURCHASE: true,
        PURCHASE_BATCH: true,
        DIGITAL_SHOEBOX: true,
        BANK: true,
        BANK_BATCH: true,
        BANK_RECONCILIATION: true,
        PRODUCT_INVENTORY: true,
        PRODUCT_INVENTORY_MULTI_LOCATION: true,
        PRODUCT_MULTI_UOM: true,
        PRODUCT_MULTI_PRICE: true,
        REPORT: true,
        ACCOUNTING_JOURNAL_ENTRY: true,
        ASSET: true,
        INSTRUCTION: true,
        MULTI_CURRENCY: true,
        TAG: true,
        TAX_SST: true,
        FIELD: true,
        EMAIL_TRACKER: true,
        E_INVOICING: true,
        INVOICE_REMINDER: true,
        PAYMENT_GATEWAY: true,
        MULTI_USER: true,
        MULTI_NUMBER_FORMAT: true,
        MULTI_FORM_DESIGN: true,
    },
    is_trial: false,
};

// Current - Lower tier plan = New/Upcoming
const newSubscription = {
    status: "active",
    trial_ends_at: "2022-08-26 12:04:26",
    ends_at: null,
    suspended_at: null,
    billing_cycle_anchor: "2024-08-23",
    addon_packs: [
        {
            name: "5GB Storage Pack",
            type: "STORAGE",
            value: "5",
            monthly_price: 6.9,
            yearly_price: 69,
            quantity: 5,
        },
        {
            name: "100 Files WhatsApp Pack",
            type: "WHATSAPP",
            value: "100",
            monthly_price: 14.9,
            yearly_price: 149,
            quantity: 0,
        },
        {
            name: "5000 Emails Pack",
            type: "EMAIL",
            value: "5000",
            monthly_price: 14.9,
            yearly_price: 149,
            quantity: 1,
        },
    ],
    is_past_due: false,
    plan_id: 8,
    plan: {
        id: 8,
        name: "Bukku Growth (Monthly)",
        description: "Growth.",
        billing_cycle: 1,
        unit_price: 59,
        type: "GROWTH",
        created_at: "2022-06-16 20:59:30",
        updated_at: "2022-06-16 20:59:30",
        // quotas: QuotaDummyGrowth, // <--- new
        quotas: QuotaDummyGrowth.reduce((acc, cur) => {
            acc[cur.type] = cur.allocation;
            return acc;
        }, {}),
        quota_period: "MONTHLY", // <--- new: Or YEARLY
        scopes: {
            SALE: true,
            SALE_BATCH: true,
            PURCHASE: true,
            PURCHASE_BATCH: true,
            DIGITAL_SHOEBOX: true,
            BANK: true,
            BANK_BATCH: true,
            BANK_RECONCILIATION: true,
            PRODUCT_INVENTORY: true,
            PRODUCT_INVENTORY_MULTI_LOCATION: true,
            PRODUCT_MULTI_UOM: true,
            PRODUCT_MULTI_PRICE: true,
            REPORT: true,
            ACCOUNTING_JOURNAL_ENTRY: true,
            ASSET: true,
            INSTRUCTION: true,
            MULTI_CURRENCY: true,
            TAG: true,
            TAX_SST: true,
            FIELD: true,
            EMAIL_TRACKER: true,
            E_INVOICING: true,
            INVOICE_REMINDER: true,
            PAYMENT_GATEWAY: true,
            MULTI_USER: true,
            MULTI_NUMBER_FORMAT: true,
            MULTI_FORM_DESIGN: true,
        },
    },
    scopes: {
        SALE: true,
        SALE_BATCH: true,
        PURCHASE: true,
        PURCHASE_BATCH: true,
        DIGITAL_SHOEBOX: true,
        BANK: true,
        BANK_BATCH: true,
        BANK_RECONCILIATION: true,
        PRODUCT_INVENTORY: true,
        PRODUCT_INVENTORY_MULTI_LOCATION: true,
        PRODUCT_MULTI_UOM: true,
        PRODUCT_MULTI_PRICE: true,
        REPORT: true,
        ACCOUNTING_JOURNAL_ENTRY: true,
        ASSET: true,
        INSTRUCTION: true,
        MULTI_CURRENCY: true,
        TAG: true,
        TAX_SST: true,
        FIELD: true,
        EMAIL_TRACKER: true,
        E_INVOICING: true,
        INVOICE_REMINDER: true,
        PAYMENT_GATEWAY: true,
        MULTI_USER: true,
        MULTI_NUMBER_FORMAT: true,
        MULTI_FORM_DESIGN: true,
    },
    is_trial: false,
};

// Previous = Higher tier plan = Old/Current
const oldClientSubscription = {
    status: "active",
    trial_ends_at: "2022-08-26 12:04:26",
    ends_at: "2023-08-22 12:04:26",
    suspended_at: null,
    billing_cycle_anchor: "2023-08-22",
    addon_packs: [
        {
            name: "5GB Storage Pack",
            type: "STORAGE",
            value: "5",
            monthly_price: 6.9,
            yearly_price: 69,
            quantity: 3,
        },
        {
            name: "100 Files WhatsApp Pack",
            type: "WHATSAPP",
            value: "100",
            monthly_price: 14.9,
            yearly_price: 149,
            quantity: 2,
        },
    ],
    is_past_due: false,
    plan_id: 5,
    plan: {
        id: 5,
        name: "Bukku Premium (Monthly)",
        description: "Premium.",
        billing_cycle: 1,
        unit_price: 99,
        type: "PREMIUM",
        quotas: QuotaDummyPremium.reduce((acc, cur) => {
            acc[cur.type] = cur.allocation;
            return acc;
        }, {}),
        quota_period: "MONTHLY", // <--- new: Or YEARLY
    },
    is_trial: false,
};

const newClientSubscription = {
    status: "active",
    trial_ends_at: "2022-08-26 12:04:26",
    ends_at: null,
    suspended_at: null,
    billing_cycle_anchor: "2024-08-23",
    addon_packs: [
        {
            name: "5 Users Pack",
            type: "USER",
            value: "5",
            monthly_price: 6.9,
            yearly_price: 69,
            quantity: 2,
        },
    ],
    is_past_due: false,
    plan_id: 4,
    plan: {
        id: 4,
        name: "Bukku Two",
        description: "Limited to 1000 transactions / year. Designed for yearly accounts.",
        billing_cycle: 1,
        unit_price: 17.9,
        type: "TWO",
        quotas: QuotaDummyGrowth.reduce((acc, cur) => {
            acc[cur.type] = cur.allocation;
            return acc;
        }, {}),
        quota_period: "MONTHLY", // <--- new: Or YEARLY

    },
    is_trial: false,
};

export const dummySubscriptionEng3265 = {

    status: "active", // trial, trial_ended, active, active_trial, grace_period, ended
    trial_ends_at: null, // Will have value if the company eligible for free trial during signup
    ends_at: null, // Have value if subscription cancelled (could be in future, ie grace period)
    suspended_at: null, // For partner's client only, due to partner account ended.
    is_past_due: false, // Stripe retrying payments.
    billing_cycle_anchor: "2021-08-03 23:12:12", // Upgraded

    current_plan_id: newSubscription.current_plan_id, // Renamed
    current_plan: newSubscription.plan, // always have value. always pointing most up to date plan, even if it’s pending to be kicked in (due to DOWNGRADE)
    current_addons: newSubscription.addon_packs, // always have value. always pointing most up to date addon packs, even if it’s pending to be kicked in (due to DOWNGRADE)

    // previous_plan_id: null,
    // previous_plan: null,
    // previous_plan_valid_until: null,
    // previous_addons: null,

    previous_plan_id: oldSubscription.plan_id,
    previous_plan: oldSubscription.plan, // only have value if plan DOWNGRADED, stores the higher-tier plan before downgrade
    previous_plan_valid_until: "2024-05-15 23:59:59", // New, used when downgrading
    previous_addons: oldSubscription.addon_packs, // only have value if plan DOWNGRADED, stores the higher-tier addon packs before downgrade
};

export const dummyClientSubscriptionEng3265 = {

    status: "active", // trial, trial_ended, active, active_trial, grace_period, ended
    trial_ends_at: null, // Will have value if the company eligible for free trial during signup
    ends_at: null, // Have value if subscription cancelled (could be in future, ie grace period)
    suspended_at: null, // For partner's client only, due to partner account ended.
    is_past_due: false, // Stripe retrying payments.
    billing_cycle_anchor: "2021-08-12 23:12:12", // Upgraded

    current_plan_id: newClientSubscription.current_plan_id, // Renamed
    current_plan: newClientSubscription.plan, // always have value. always pointing most up to date plan, even if it’s pending to be kicked in (due to DOWNGRADE)
    current_addons: newClientSubscription.addon_packs, // always have value. always pointing most up to date addon packs, even if it’s pending to be kicked in (due to DOWNGRADE)

    previous_plan_id: oldClientSubscription.plan_id,
    previous_plan: oldClientSubscription.plan, // only have value if plan DOWNGRADED, stores the higher-tier plan before downgrade

    // TODO: CHANGE THIS DATE to before or after today
    previous_plan_valid_until: "2024-05-21 23:59:59", // New, used when downgrading
    previous_addons: oldClientSubscription.addon_packs, // only have value if plan DOWNGRADED, stores the higher-tier addon packs before downgrade
};
